import offset from 'document-offset';

export default function getClosestElements({ siblings, element }) {
  const { document } = window;

  const currentElementTop = offset(element).top;
  const siblingTops = siblings.map(el => offset(el).top);

  return siblingTops.reduce((closest, top) => {
    const distanceFromElement = Math.abs(currentElementTop - top);
    return distanceFromElement < closest ? distanceFromElement : closest;
  }, Infinity);
}
